import compositeViewMixin from "compositeViewMixin";
import models from "models/models";
import AccountSettingsView from "views/AccountSettingsView";

const subviewManager = { ...compositeViewMixin };

export const render = (element, renderedCallback) => {
  element.html("<div class='accountSettingsView'></div>");

  const accountSettingsView = new AccountSettingsView({
    el: element.find(".accountSettingsView"),
    model: models.user,
  });
  subviewManager.addSubview("accountSettings", accountSettingsView);
  renderedCallback();
};

export const close = () => {
  subviewManager.removeSubviews();
};

export const showHeader = true;
export const name = "accountPage";
